import { render } from "./LazyVideo.vue?vue&type=template&id=ceb2e4c0"
import script from "./LazyVideo.vue?vue&type=script&lang=js"
export * from "./LazyVideo.vue?vue&type=script&lang=js"

import "./LazyVideo.vue?vue&type=style&index=0&id=ceb2e4c0&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__